import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13904a28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-trust-compliance" }
const _hoisted_2 = { class: "table-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "__left" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Trust Compliance")
], -1))
const _hoisted_4 = { class: "__right" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "ls-table" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["colspan"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["colspan"]
const _hoisted_15 = ["colspan"]
const _hoisted_16 = { "data-label": "Compliance Year" }
const _hoisted_17 = { "data-label": "Progress" }
const _hoisted_18 = { class: "status" }
const _hoisted_19 = { class: "status-icon" }
const _hoisted_20 = { class: "status-text" }
const _hoisted_21 = { "data-label": "Non-compliant" }
const _hoisted_22 = { "data-label": "Absolution" }
const _hoisted_23 = {
  "data-label": "Action",
  class: "col-action"
}

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_DropdownActions = _resolveComponent("DropdownActions")
  const _component_GenerateNextYearComplianceModel = _resolveComponent("GenerateNextYearComplianceModel")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = $event => {_ctx.generateNextYearComplianceFormButtonClicked();}),
          disabled: !_ctx.generateComplianceFormAllowed
        }, "Generate Trust Compliance Form", 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("table", _hoisted_6, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
            return (_openBlock(), _createElementBlock("th", {
              class: _normalizeClass([ h.sortable ? 'sortable' : '']),
              onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(h.text), 1),
                (h.sortable)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', _ctx.sortMethod])
                    }, _hoisted_10, 2))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_7))
          }), 256))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.loadingContent)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
              _createElementVNode("td", {
                colspan: _ctx.tableHeadings.length
              }, [
                _createVNode(_component_LoadingIndicator)
              ], 8, _hoisted_12)
            ]))
          : (_ctx.trustComplianceTableData.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                (!_ctx.errorLoadingContent)
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 0,
                      colspan: _ctx.tableHeadings.length
                    }, "No Records", 8, _hoisted_14))
                  : (_openBlock(), _createElementBlock("td", {
                      key: 1,
                      colspan: _ctx.trustComplianceTableHeadings.length
                    }, [
                      _createVNode(_component_ErrorIndicator)
                    ], 8, _hoisted_15))
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.trustComplianceTableData, (tc, index) => {
                return (_openBlock(), _createElementBlock("tr", null, [
                  _createElementVNode("td", _hoisted_16, _toDisplayString(tc.complianceYear?.name), 1),
                  _createElementVNode("td", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("i", {
                          class: "fas fa-circle",
                          style: _normalizeStyle(_ctx.statusColorCSS(tc.progress?.id))
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(tc.progress?.name), 1)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.getNonCompliant(tc)), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.getAbsolution(tc)), 1),
                  _createElementVNode("td", _hoisted_23, [
                    _createVNode(_component_DropdownActions, {
                      practice: _ctx.trustComplianceTableData[index],
                      "onUpdate:practice": $event => ((_ctx.trustComplianceTableData[index]) = $event),
                      onReloadData: _ctx.reloadData
                    }, null, 8, ["practice", "onUpdate:practice", "onReloadData"])
                  ])
                ]))
              }), 256))
      ])
    ]),
    _createVNode(_component_GenerateNextYearComplianceModel, {
      selectedPractice: _ctx.selectedPractice,
      modalOpened: _ctx.showGenerateNextYearConfirmation,
      complianceForm: _ctx.generateComplianceForm,
      onClose: _cache[1] || (_cache[1] = $event => (_ctx.showGenerateNextYearConfirmation = !_ctx.showGenerateNextYearConfirmation)),
      onConfirmed: _ctx.generateNextYearComplianceForm
    }, null, 8, ["selectedPractice", "modalOpened", "complianceForm", "onConfirmed"])
  ]))
}